/*
 * Slide-out cart (sections/cart-drawer.liquid). Replaced the UpCart app in
 * 2026-10 and keeps its behaviour:
 *   - every add to cart opens the drawer: plain add-to-cart forms are sent
 *     with fetch instead of loading /cart, and adds other scripts make
 *     (Replo, the bundle builder, anything using fetch or XMLHttpRequest)
 *     are noticed through the browser's resource timing, which sees them
 *     even when that script kept its own copy of fetch;
 *   - the header cart link and the floating button open it;
 *   - quantity steppers, the quantity box and the bin change the line;
 *   - Escape and a click on the dimmed page close it;
 *   - above the subtotal, the visitor's country line ("Free shipping to
 *     [flag] United Kingdom"), with the product pages' rules;
 *   - the cart bump's Add button puts its product in the cart with the
 *     hidden line property _source: cart_bump (cart_bump_sheet from the
 *     info sheet);
 *   - the bump's picture, name and "More info" open its info sheet over the
 *     cart instead of leaving for the product page; Escape or the dimmed
 *     cart closes it, and the rest of the drawer is inert while it is open.
 * The drawer's contents always come from Shopify's Section Rendering API,
 * so prices and currency match the rest of the store.
 * Public: window.PipCart.open/close/refresh, window.openCartDrawer().
 */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  // Marks the drawer's own cart requests so the observer skips them.
  var OWN = 'pip_cart=1';
  var root = document.querySelector('[data-pip-cart]');
  if (!root || window.PipCart) return;

  var panel = root.querySelector('[data-pip-cart-panel]');
  var errorEl = root.querySelector('[data-pip-cart-error]');
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var opener = null;
  var infoOpener = null;
  var inerted = [];

  // The same rules as the product page line: snippets/country-flag-no-time.liquid
  // picks the wording, and the 'shipping-estimate-no-time' block in
  // snippets/product-blocks.liquid shows the line only for these countries.
  // Change all three together.
  var FREE_SHIPPING = [
    'ad', 'at', 'be', 'ba', 'bg', 'hr', 'cz', 'dk', 'ee', 'fo', 'fi', 'fr', 'de', 'gi', 'gr',
    'gg', 'hu', 'is', 'ie', 'im', 'it', 'je', 'xk', 'lv', 'li', 'lt', 'lu', 'mt', 'md', 'mc',
    'me', 'nl', 'mk', 'no', 'pl', 'pt', 'ro', 'sm', 'rs', 'sk', 'si', 'es', 'sj', 'se', 'ch',
    'va', 'us', 'gb', 'ca'
  ];
  var SHIPPING_LINE_COUNTRIES = ['us', 'gb', 'ca', 'fr', 'au', 'nz', 'de', 'nl', 'be', 'dk', 'it', 'no', 'pl', 'es', 'se', 'ch'];
  var country = null; // { code, name } once known, false when not shown
  var countryRequest = null;

  function cartPath(url) {
    try {
      return new URL(url, window.location.href).pathname.replace(/\/$/, '');
    } catch (e) {
      return '';
    }
  }

  function loadCountry() {
    if (!countryRequest) {
      countryRequest = window.fetch(shopRoot + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var detected = data && data.detected_values && data.detected_values.country;
          var code = detected && String(detected.handle || '').toLowerCase();
          country = code && SHIPPING_LINE_COUNTRIES.indexOf(code) !== -1 ? { code: code, name: detected.name } : false;
        })
        .catch(function () { country = false; })
        .then(showShippingLine);
    }
    return countryRequest;
  }

  function showShippingLine() {
    var el = root.querySelector('[data-pip-cart-shipping]');
    if (!el || country === null) return;
    if (!country) {
      el.hidden = true;
      return;
    }
    var flag = document.createElement('img');
    flag.src = 'https://flagcdn.com/16x12/' + country.code + '.png';
    flag.srcset = 'https://flagcdn.com/32x24/' + country.code + '.png 2x, https://flagcdn.com/48x36/' + country.code + '.png 3x';
    flag.width = 16;
    flag.height = 12;
    flag.alt = country.name;
    var name = document.createElement('strong');
    name.textContent = country.name;
    var wording = document.createElement('span');
    wording.textContent = FREE_SHIPPING.indexOf(country.code) !== -1 ? 'Free shipping to ' : 'Ships in 5-7 days to ';
    el.replaceChildren(wording, ' ', flag, ' ', name);
    el.hidden = false;
  }

  function isOpen() {
    return root.classList.contains('is-open');
  }

  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open() {
    if (isOpen()) return;
    opener = document.activeElement;
    loadCountry();
    root.classList.add('is-open');
    document.documentElement.classList.add('pip-cart-locked');
    var close = panel.querySelector('.pip-cart__close');
    window.setTimeout(function () { (close || panel).focus({ preventScroll: true }); }, 30);
  }

  function close() {
    if (!isOpen()) return;
    closeInfo(false);
    root.classList.remove('is-open');
    document.documentElement.classList.remove('pip-cart-locked');
    showError('');
    if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    opener = null;
  }

  function showError(message) {
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  function setCount(count) {
    document.querySelectorAll('[data-cart-count], [data-pip-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  // layout/theme.liquid superscripts ® and ™ once, on page load; HTML the
  // drawer swaps in later needs the same treatment.
  function superscriptMarks(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return /[®™]/.test(node.nodeValue) && !node.parentNode.closest('sup')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/([®™])/).forEach(function (part, i) {
        if (!part) return;
        if (i % 2) {
          var sup = document.createElement('sup');
          sup.className = 'tm-sup';
          sup.textContent = part;
          frag.appendChild(sup);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      node.replaceWith(frag);
    });
  }

  function sheet() {
    return root.querySelector('[data-pip-cart-sheet]');
  }

  function isInfoOpen() {
    var el = sheet();
    return !!el && el.classList.contains('is-open');
  }

  // While the info sheet is open, the rest of the drawer is inert, so Tab,
  // screen readers and clicks stay inside the sheet.
  function setInert(on) {
    inerted.forEach(function (el) { el.inert = false; });
    inerted = [];
    var el = sheet();
    if (!on || !el) return;
    var region = el.parentNode;
    Array.prototype.forEach.call(panel.children, function (child) {
      if (child !== region) inerted.push(child);
    });
    Array.prototype.forEach.call(region.children, function (child) {
      if (child !== el) inerted.push(child);
    });
    inerted.forEach(function (child) { child.inert = true; });
  }

  function openInfo(trigger) {
    var el = sheet();
    if (!el || isInfoOpen()) return;
    infoOpener = trigger;
    el.classList.add('is-open');
    setInert(true);
    var close = el.querySelector('.pip-cart__close');
    window.setTimeout(function () { (close || el).focus({ preventScroll: true }); }, 30);
  }

  // The picture and name are mouse shortcuts kept out of the Tab order, so
  // focus goes back to "More info" when one of them opened the sheet.
  function closeInfo(restoreFocus) {
    setInert(false);
    var el = sheet();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    var back = infoOpener;
    infoOpener = null;
    if (!restoreFocus) return;
    if (!back || !panel.contains(back) || back.getAttribute('tabindex') === '-1') {
      back = panel.querySelector('.pip-cart__bump-more') || panel.querySelector('.pip-cart__close');
    }
    if (back) back.focus({ preventScroll: true });
  }

  function stepGallery(button) {
    var track = button.parentNode.querySelector('[data-pip-cart-gallery]');
    var count = track.children.length;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    var next = (index + Number(button.getAttribute('data-pip-cart-gallery-step')) + count) % count;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: next * track.clientWidth, behavior: still ? 'auto' : 'smooth' });
  }

  // Swap the drawer's changing parts for the server-rendered copy.
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var parsed = doc.querySelector('[data-pip-cart-region="body"]');
    var current = root.querySelector('[data-pip-cart-region="body"]');
    if (!parsed || !current) return;
    var fresh = document.importNode(parsed, true);
    superscriptMarks(fresh);
    // The fresh copy's info sheet starts closed.
    setInert(false);
    infoOpener = null;
    current.replaceWith(fresh);
    setCount(fresh.getAttribute('data-item-count') || '0');
    showShippingLine();
    // The control that had focus may have been replaced or removed.
    if (isOpen() && !panel.contains(document.activeElement)) {
      (panel.querySelector('.pip-cart__close') || panel).focus({ preventScroll: true });
    }
  }

  function refresh() {
    return window.fetch(shopRoot + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data[SECTION]); })
      .catch(function () {});
  }

  function errorMessage(res) {
    return res.json()
      .then(function (body) { return body.description || body.message || 'Sorry, that did not work.'; })
      .catch(function () { return 'Sorry, that did not work.'; });
  }

  function changeLine(line, quantity) {
    var row = root.querySelector('.pip-cart__item[data-line="' + line + '"]');
    if (row) row.classList.add('is-busy');
    return window.fetch(shopRoot + 'cart/change.js?' + OWN, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION, sections_url: window.location.pathname })
    }).then(function (res) {
      if (!res.ok) {
        return errorMessage(res).then(function (message) {
          showError(message);
          return refresh();
        });
      }
      showError('');
      return res.json().then(function (cart) {
        if (cart.sections && cart.sections[SECTION]) render(cart.sections[SECTION]);
        else return refresh();
      });
    }).catch(function () {
      if (row) row.classList.remove('is-busy');
    });
  }

  function addForm(form, submitter) {
    var body;
    try {
      body = new FormData(form, submitter);
    } catch (e) {
      body = new FormData(form);
      if (submitter && submitter.name) body.append(submitter.name, submitter.value);
    }
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    return window.fetch(shopRoot + 'cart/add.js?' + OWN, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (res) {
      if (!res.ok) {
        return errorMessage(res).then(function (message) {
          showError(message);
          return refresh().then(open);
        });
      }
      showError('');
      return refresh().then(open);
    }).catch(function () {
      form.submit();
    }).then(function () {
      if (submitter) submitter.removeAttribute('aria-busy');
    });
  }

  function addBump(button) {
    button.setAttribute('aria-busy', 'true');
    return window.fetch(shopRoot + 'cart/add.js?' + OWN, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(button.getAttribute('data-pip-cart-bump')),
          quantity: 1,
          properties: { _source: button.getAttribute('data-pip-cart-source') || 'cart_bump' }
        }],
        sections: SECTION,
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      if (!res.ok) {
        return errorMessage(res).then(function (message) {
          showError(message);
          button.removeAttribute('aria-busy');
        });
      }
      showError('');
      return res.json().then(function (body) {
        if (body.sections && body.sections[SECTION]) render(body.sections[SECTION]);
        else return refresh();
      });
    }).catch(function () {
      button.removeAttribute('aria-busy');
    });
  }

  // Another script wrote to the cart: refresh, and open on an add.
  function afterCartWrite(url) {
    var path = cartPath(url);
    refresh().then(function () {
      if (/\/cart\/add(\.js)?$/.test(path)) open();
    });
  }

  function watchCartWrites() {
    if (!('PerformanceObserver' in window)) return;
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') return;
          if (entry.name.indexOf(OWN) !== -1 || !CART_WRITE.test(cartPath(entry.name))) return;
          // responseStatus is 0 where the browser does not report it.
          if (entry.responseStatus && entry.responseStatus >= 400) return;
          afterCartWrite(entry.name);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  watchCartWrites();

  // Add-to-cart forms that no other script has taken over.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-pip-cart') === 'off') return;
    if (!/\/cart\/add(\.js)?$/.test(cartPath(form.getAttribute('action') || ''))) return;
    event.preventDefault();
    addForm(form, event.submitter);
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target.closest('[data-pip-cart-close], [data-pip-cart-open], [data-cart-button], a[href]');
    if (!target) return;

    if (target.hasAttribute('data-pip-cart-close')) {
      event.preventDefault();
      close();
      return;
    }
    var isCartLink = target.hasAttribute('data-pip-cart-open') || target.hasAttribute('data-cart-button') ||
      (target.matches('a[href]') && !panel.contains(target) && cartPath(target.getAttribute('href')) === cartPath(shopRoot + 'cart'));
    if (isCartLink) {
      event.preventDefault();
      open();
      refresh();
    }
  });

  root.addEventListener('click', function (event) {
    var bump = event.target.closest('[data-pip-cart-bump]');
    if (bump) {
      addBump(bump);
      return;
    }
    var info = event.target.closest('[data-pip-cart-info]');
    if (info) {
      openInfo(info);
      return;
    }
    if (event.target.closest('[data-pip-cart-info-close]')) {
      closeInfo(true);
      return;
    }
    var picture = event.target.closest('[data-pip-cart-gallery-step]');
    if (picture) {
      stepGallery(picture);
      return;
    }
    var step = event.target.closest('[data-pip-cart-step]');
    var remove = event.target.closest('[data-pip-cart-remove]');
    if (!step && !remove) return;
    var row = event.target.closest('.pip-cart__item');
    if (!row) return;
    var line = Number(row.getAttribute('data-line'));
    var input = row.querySelector('[data-pip-cart-qty]');
    var quantity = remove ? 0 : Math.max(0, Number(input.value || 0) + Number(step.getAttribute('data-pip-cart-step')));
    changeLine(line, quantity);
  });

  root.addEventListener('change', function (event) {
    var input = event.target.closest('[data-pip-cart-qty]');
    if (!input) return;
    var row = input.closest('.pip-cart__item');
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(Number(row.getAttribute('data-line')), quantity);
  });

  // The gallery's dots follow a swipe or a scroll.
  root.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!(track instanceof Element) || !track.hasAttribute('data-pip-cart-gallery')) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    track.parentNode.querySelectorAll('.pip-cart__gallery-dots span').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    var infoOpen = isInfoOpen();
    if (event.key === 'Escape') {
      event.preventDefault();
      if (infoOpen) closeInfo(true);
      else close();
      return;
    }
    if (event.key !== 'Tab') return;
    var container = infoOpen ? sheet().querySelector('[data-pip-cart-sheet-box]') : panel;
    var items = focusables(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!container.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && (document.activeElement === first || document.activeElement === container)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // Coming back with the browser's back button can show a stale cart.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  window.PipCart = { open: open, close: close, refresh: refresh };
  window.openCartDrawer = open;
})();
